var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 560,
    viewBox: "0 0 560 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 140H140V280H280V140Z",
    fill: "#4650EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M247.427 228.503L231.035 244.907L211.715 225.575L192.068 245.233L174.767 227.932L194.413 208.285L176.353 190.213L192.745 173.822L210.805 191.882L229.448 173.25L246.75 190.54L228.107 209.183L247.427 228.503Z",
    fill: "#FFEEF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140 140H0V280H140V140Z",
    fill: "#4650EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 280L140 209.977H0L70 280Z",
    fill: "#FFEEF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70 210.023L0 140H140L70 210.023Z",
    fill: "#FFEEF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M420 0H280V140H420V0Z",
    fill: "#FFEEF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M400.528 121.217H297.488V18.2583H400.528V121.217ZM313.693 105.093H384.312V34.3816H313.705V105.082L313.693 105.093Z",
    fill: "#4650EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M365.925 51.9749H334.075V83.6732H365.925V51.9749Z",
    fill: "#4650EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M560 0H420V140H560V0Z",
    fill: "#FFEEF0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M490.07 140C451.407 140 420.047 108.745 420.047 70.1748C458.722 70.1748 490.07 101.43 490.07 140Z",
    fill: "#3340BC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M489.953 140C528.628 140 559.977 108.745 559.977 70.1748C521.302 70.1748 489.953 101.43 489.953 140Z",
    fill: "#4650EF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M490.07 69.9297C451.407 69.9297 420.047 38.6747 420.047 0.104736C458.722 0.104736 490.07 31.3714 490.07 69.9297Z",
    fill: "#3340BC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M489.953 69.9297C528.628 69.9297 559.977 38.6747 559.977 0.104736C521.302 0.104736 489.953 31.3714 489.953 69.9297Z",
    fill: "#4650EF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140 0H0V140H140V0Z",
    fill: "#4650EF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 140H86.66C86.66 110.542 110.542 86.6604 140 86.6604V0.0354004H136.943C61.04 1.65707 0 63.7004 0 140Z",
    fill: "#FFEEF0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M280 0H140V140H280V0Z",
    fill: "#4650EF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M280 0C241.488 0.151667 210.315 31.43 210.315 70C210.315 108.57 241.488 139.848 280 140V0Z",
    fill: "#FFEEF0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M140 140C178.512 139.848 209.685 108.57 209.685 70C209.685 31.43 178.512 0.151667 140 0V140Z",
    fill: "#FFEEF0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M560 140H420V280H560V140Z",
    fill: "#4650EF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M458.22 162.739L444.197 187.029H472.243L458.22 162.739Z",
    fill: "#FFEEF0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M490.315 162.668L476.292 186.958H504.338L490.315 162.668Z",
    fill: "#FFEEF0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M522.41 162.598L508.387 186.888H536.433L522.41 162.598Z",
    fill: "#FFEEF0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M458.22 196.7L444.197 220.99H472.243L458.22 196.7Z",
    fill: "#FFEEF0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M490.315 196.63L476.292 220.92H504.338L490.315 196.63Z",
    fill: "#FFEEF0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M522.41 196.56L508.387 220.85H536.433L522.41 196.56Z",
    fill: "#FFEEF0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M458.22 230.662L444.197 254.952H472.243L458.22 230.662Z",
    fill: "#FFEEF0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M490.315 230.592L476.292 254.882H504.338L490.315 230.592Z",
    fill: "#FFEEF0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M522.41 230.521L508.387 254.811H536.433L522.41 230.521Z",
    fill: "#FFEEF0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M420 140H280V280H420V140Z",
    fill: "#FFEEF0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M420 140C381.488 140.152 350.315 171.43 350.315 210C350.315 248.57 381.488 279.848 420 280V140Z",
    fill: "#4650EF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M280 280C318.512 279.848 349.685 248.57 349.685 210C349.685 171.43 318.512 140.152 280 140V280Z",
    fill: "#4650EF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M140 280H0V420H140V280Z",
    fill: "#4650EF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3199 337.855C48.4321 337.855 55.0083 331.279 55.0083 323.167C55.0083 315.055 48.4321 308.479 40.3199 308.479C32.2078 308.479 25.6316 315.055 25.6316 323.167C25.6316 331.279 32.2078 337.855 40.3199 337.855Z",
    fill: "#FFEEF0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7767 337.855C101.889 337.855 108.465 331.279 108.465 323.167C108.465 315.055 101.889 308.479 93.7767 308.479C85.6646 308.479 79.0884 315.055 79.0884 323.167C79.0884 331.279 85.6646 337.855 93.7767 337.855Z",
    fill: "#1F266D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7767 387.893C101.889 387.893 108.465 381.317 108.465 373.205C108.465 365.093 101.889 358.516 93.7767 358.516C85.6646 358.516 79.0884 365.093 79.0884 373.205C79.0884 381.317 85.6646 387.893 93.7767 387.893Z",
    fill: "#FFEEF0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3199 387.893C48.4321 387.893 55.0083 381.317 55.0083 373.205C55.0083 365.093 48.4321 358.516 40.3199 358.516C32.2078 358.516 25.6316 365.093 25.6316 373.205C25.6316 381.317 32.2078 387.893 40.3199 387.893Z",
    fill: "#1F266D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M280 280H140V420H280V280Z",
    fill: "#FFEEF0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M279.953 350C279.953 388.64 248.617 419.977 209.953 420V381.558C229.238 381.558 244.86 365.937 244.86 346.675C244.86 327.413 229.227 311.792 209.953 311.792V280C248.617 280.023 279.953 311.36 279.953 350Z",
    fill: "#4650EF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M210 350C210 388.64 178.663 419.977 140 420V381.558C159.285 381.558 174.907 365.937 174.907 346.675C174.907 327.413 159.285 311.78 140 311.78V280C178.663 280.023 210 311.36 210 350Z",
    fill: "#4650EF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M420 280H280V420H420V280Z",
    fill: "#FFEEF0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M280 350L350 420V280L280 350Z",
    fill: "#4650EF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M350 350L420 280V420L350 350Z",
    fill: "#4650EF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M560 280H420V420H560V280Z",
    fill: "#4650EF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M541.31 401.321H438.585V298.678H541.31V401.321ZM454.743 385.245H525.152V314.755H454.743V385.245Z",
    fill: "#FFEEF0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M506.812 332.29H475.055V363.883H506.812V332.29Z",
    fill: "#FFEEF0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M140 420H0V560H140V420Z",
    fill: "#4650EF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 420H0V490H17.5V420Z",
    fill: "#FFEEF0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 420H35V490H52.5V420Z",
    fill: "#EFCACF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 420H70V490H87.5V420Z",
    fill: "#FFEEF0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 420H105V490H122.5V420Z",
    fill: "#EFCACF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M35 490H17.5V560H35V490Z",
    fill: "#FFEEF0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M70 490H52.5V560H70V490Z",
    fill: "#EFCACF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M105 490H87.5V560H105V490Z",
    fill: "#FFEEF0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M140 490H122.5V560H140V490Z",
    fill: "#EFCACF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_855_1698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 280,
    y: 420,
    width: 140,
    height: 140
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M420 420H280V560H420V420Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_855_1698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.942 419.907H279.942V559.907H419.942V419.907Z",
    fill: "#FFEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.953 360.489L220.687 489.755L349.953 619.022L479.22 489.755L349.953 360.489ZM237.883 489.755L349.953 377.685L462.012 489.744L349.953 601.802L237.883 489.755Z",
    fill: "#4650EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.953 394.882L255.08 489.755L349.942 584.617L444.803 489.755L349.953 394.882ZM272.288 489.755L349.953 412.09L427.618 489.755L349.953 567.42L272.288 489.755Z",
    fill: "#4650EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.953 429.287L289.485 489.755L349.953 550.224L410.422 489.755L349.953 429.287ZM306.682 489.755L349.953 446.484L393.225 489.755L349.953 533.027L306.682 489.755Z",
    fill: "#4650EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.953 463.68L323.89 489.744L349.953 515.807L376.017 489.744L349.953 463.68ZM341.087 489.744L349.953 480.877L358.82 489.744L349.953 498.61L341.087 489.744Z",
    fill: "#4650EF"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M280 420H140V560H280V420Z",
    fill: "#4650EF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M209.743 560H140V490L209.743 560Z",
    fill: "#FFEEF0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M209.743 490H140V420L209.743 490Z",
    fill: "#FFEEF0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M280 560H210.257V490L280 560Z",
    fill: "#FFEEF0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M280 490H210.257V420L280 490Z",
    fill: "#FFEEF0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M560 420H420V560H560V420Z",
    fill: "#4650EF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M420 560V473.34C449.458 473.34 473.34 449.458 473.34 420H560C560 497.327 497.315 560 420 560Z",
    fill: "#FFEEF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSquare);
export default __webpack_public_path__ + "static/media/Footer Square.3f59227679b9a446bbafbfc301f922c7.svg";
export { ForwardRef as ReactComponent };